import * as React from "react";
import { CSSProperties, useRef, useState } from "react";
import { Popover } from "@mui/material/";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { makeStyles } from "@mui/styles";
import { CommonColors } from "fe-web-components/colors/commonColors";
import { CSSCollapseTransitionComponent } from "../patientCard/layout/CSSCollapseTransitionComponent";
// import {
//   ADDON_Z_INDEX,
//   STACKING,
// } from "chrome-extenstion/src/layout/addonStacking";
export const ADDON_Z_INDEX = 9999;

export const enum STACKING {
  TOP_MOST = 1000,
  FRONT = 100,
  NORMAL = 50,
  BACK = 1,
}

//region [[ Styles ]]

//endregion [[ Styles ]]
const useStyles = makeStyles({
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
    padding: 10,
    overflow: "visible",
    maxWidth: 300,
    "&::before": {
      boxShadow: "-4px -3px 3px 0 rgba( 178, 178, 178, .4 )",
      bottom: "-4px",
      right: "14px",
      width: "14px",
      height: "14px",
      content: "''",
      display: "block",
      position: "absolute",
      transform: "rotate( 225deg )",
      backgroundColor: "#ffffff",
    },
  },
  icon: {
    color: CommonColors.DefaultDark,
    height: 18,
    width: 18,
  },
});
//region [[ Props ]]

export interface InfoPopoverProps {
  text: React.ReactElement | string;
  open?: boolean;
  iconStyle?: CSSProperties;
  inExtension?: boolean; // When in extension use CSSCollapseTransitionComponent
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InfoPopover = ({ ...props }: InfoPopoverProps) => {
  const [openedPopover, setOpenedPopover] = useState(false);
  const popoverAnchor = useRef(null);
  const popoverRef = useRef(null);

  const handlePopoverOpen = () => {
    setOpenedPopover(true);
  };
  const handlePopoverClose = () => {
    setOpenedPopover(false);
  };
  const classes = useStyles();

  return (
    <>
      <div
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{
          ...(props.iconStyle || {}),
          zIndex: ADDON_Z_INDEX + STACKING.TOP_MOST,
        }}
        ref={popoverAnchor}
      >
        <InfoOutlinedIcon fontSize={"small"} className={classes.icon} />
      </div>
      <Popover
        open={openedPopover || props.open}
        ref={popoverRef}
        anchorOrigin={{
          vertical: -8,
          horizontal: 31,
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        style={
          popoverAnchor.current && props.inExtension
            ? {
                width: "300px",
                height: "87px",
                zIndex: ADDON_Z_INDEX + STACKING.TOP_MOST,
                top:
                  popoverAnchor.current.getBoundingClientRect?.()?.top -
                  18 -
                  45,
                left:
                  popoverAnchor.current.getBoundingClientRect?.()?.left -
                  300 +
                  30,
              }
            : {}
        }
        anchorEl={popoverAnchor.current}
        disableRestoreFocus
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        PaperProps={{
          onMouseEnter: handlePopoverOpen,
          onMouseLeave: handlePopoverClose,
        }}
        TransitionComponent={
          props.inExtension ? CSSCollapseTransitionComponent : undefined
        }
        //transistion={props.inExtension ? false : true}
      >
        {props.text}
      </Popover>
    </>
  );
};
